/**
 * Helper for responsive images a la
 * <img class="resp-image" data-resp-base="images/" data-resp="image.png:s,480:image-medium.png:m,960:image-big.jpg:l" />
 *
 * data-resp-base: the image base path
 * data-resp: comma separated list with $breakpoint:$image:$className
 */
import fetch from 'unfetch';
import { debounce, forEachEl } from './utils';

function init() {
  updateElements();
  bindEvents();
}

function updateElements() {
  const respElements = document.querySelectorAll('.resp-image:not(.lazy), .resp-content:not(.lazy)');
  forEachEl(respElements, updateElement);
}

function bindEvents() {
  const debouncedResize = debounce(updateElements, 100);
  window.addEventListener('resize', debouncedResize);
}

async function updateElement(el) {
  const baseUrl = el.getAttribute('data-resp-base');
  const respRules = el.getAttribute('data-resp');

  if (typeof baseUrl === 'undefined' || typeof respRules === 'undefined') {
    return el;
  }
  
  let currRule;
  const classNames = [].map.call(el.classList, c => c);
  const rules = respRules.split(',').map((rule, i) => {
    rule = i === 0 ? `0:${rule}` : rule;
    const ruleSplitted = rule.split(':');
    return [+ruleSplitted[0], ruleSplitted[1], ruleSplitted[2]]
  }).sort((a, b) => b[0] - a[0]);

  for (let i = 0; i < rules.length; i++) {
    currRule = rules[i];
    if (window.innerWidth > currRule[0]) {
      break;
    }
  }

  // these are the original classes of the img
  const baseClasses = classNames.filter(c => !rules.filter((r) => r[2] === c).length && c !== 'lazy');
  
  if (baseClasses.indexOf('resp-image') >= 0) {
    el.setAttribute('src', `${baseUrl}${currRule[1]}`);
  }

  if (baseClasses.indexOf('resp-content') >= 0) {
    const currUrl = el.getAttribute('data-src');
    
    if (currUrl !== currRule[1]) {
      try {
        const req = await fetch(`${baseUrl}${currRule[1]}`);
        const content = await req.text();
        el.innerHTML = content;
      } catch(e) {
        console.log('error loading responsive content:', e);
      }
    }

    el.setAttribute('data-src', currRule[1]);
  }

  el.className = `${baseClasses.join(' ')} ${currRule[2]}`;
}

export default {
  init,
  updateElement
}
